/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';
import { jsx } from '@compiled/react';
import AvatarGroup from '@atlaskit/avatar-group';

import { type JoinableSiteUserAvatarPropTypes } from '../../types';
import {
	createAndFireNavigationEvent,
	withAnalyticsEvents,
	type WithAnalyticsEventsProps,
	UI_EVENT_TYPE,
	SWITCHER_ITEM_SUBJECT,
} from '../../common/utils/analytics';
import { FadeIn } from './fade-in';
import ThemedItem from './themed-item';

export interface ItemWithAvatarGroupProps extends WithAnalyticsEventsProps {
	children: React.ReactNode;
	icon: React.ReactNode;
	description?: React.ReactNode;
	href?: string;
	isDisabled?: boolean;
	onKeyDown?: any;
	onItemClick?: (e: React.SyntheticEvent) => void;
	users?: JoinableSiteUserAvatarPropTypes[];
	target?: string;
	rel?: string;
	tag?: keyof JSX.IntrinsicElements | undefined;
	maxCount?: number;
}
const noop = () => {};

class ItemWithAvatarGroup extends React.Component<ItemWithAvatarGroupProps> {
	render() {
		const {
			icon,
			description,
			users = [],
			onItemClick,
			tag = 'li',
			maxCount = 3,
			...rest
		} = this.props;

		return (
			<FadeIn tag={tag}>
				<ThemedItem
					description={description}
					icon={icon}
					elemAfter={
						<AvatarGroup
							appearance="stack"
							data={users}
							maxCount={maxCount}
							size="small"
							onMoreClick={noop}
						/>
					}
					onClick={onItemClick}
					{...rest}
				/>
			</FadeIn>
		);
	}
}

export default withAnalyticsEvents({
	onItemClick: createAndFireNavigationEvent({
		eventType: UI_EVENT_TYPE,
		action: 'clicked',
		actionSubject: SWITCHER_ITEM_SUBJECT,
	}),
})(ItemWithAvatarGroup);
